import { useState } from 'react';
import { AtSign, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const DISMISSED_KEY = (uid) => `markerSync_usernameBannerDismissed_${uid}`;

export default function UsernameBanner({ onSetUsername }) {
  const { user, loading } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  const isDismissed = () => {
    if (typeof window === 'undefined' || !user) return true;
    return !!localStorage.getItem(DISMISSED_KEY(user.uid));
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(DISMISSED_KEY(user.uid), '1');
  };

  // Only show for logged-in users without a username
  if (loading || !user || user.username || dismissed || isDismissed()) return null;

  return (
    <div className="bg-gradient-to-r from-purple-50 via-pink-50 to-purple-50 border-b border-purple-100">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="p-1.5 bg-purple-100 rounded-lg shrink-0">
              <AtSign size={18} className="text-purple-600" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium text-slate-800">
                You can now set a username!
              </p>
              <p className="text-xs text-slate-600 hidden sm:block">
                Choose a unique handle to display on your public gallery palettes.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={onSetUsername}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium rounded-lg transition-colors"
            >
              <AtSign size={14} />
              <span className="hidden sm:inline">Set username</span>
              <span className="sm:hidden">Set</span>
            </button>
            <button
              onClick={handleDismiss}
              className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
              title="Dismiss"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
